import querystring from 'querystring';
import jwt from 'jsonwebtoken';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'empty',
  data() {
    return {
      loaded: false,
      submitted: false,
      userId: null,
      count: 0
    };
  },
  head() {
    return {
      title: 'Friend Pass - EXTRA'
    };
  },
  watch: {
    loaded(val) {
      if (!val) {
        return;
      }
      const {
        token,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content,
        callback
      } = this.$route.query;
      if (callback !== undefined) {
        // window.localStorage.setItem('friendpass_sent_2', true)

        window.extra_data_ul.log([{
          app: 'friendpass-v1',
          kingdom: 'finish'
        }]);
        this.submitted = true;
        return;
      }
      this.submitted = !!window.localStorage.getItem('friendpass_sent_2');
      if (token) {
        try {
          this.userId = jwt.decode(token).user.id;
        } catch {}
      }
      if (!this.submitted && this.userId) {
        window.extra_data_ul.log([{
          app: 'friendpass-v1',
          kingdom: 'start',
          phylum: 'success'
        }]);
        const query = querystring.stringify({
          user_tag: window.g_user_tag,
          device_tag: window.g_device_tag,
          user_id: this.userId,
          extra_token: token,
          utm_source,
          utm_medium,
          utm_campaign,
          utm_term,
          utm_content
        });
        setTimeout(() => {
          const url = `https://form.typeform.com/to/mrBG4ih3?${query}`;
          window.location.href = url;
          // console.log('redirect', url)
        }, 200);
      } else {
        window.extra_data_ul.log([{
          app: 'friendpass-v1',
          kingdom: 'start',
          phylum: 'fail',
          class: !this.userId ? 'invalid_token' : this.submitted ? 'already_submitted' : ''
        }]);
      }
    }
  },
  mounted() {},
  methods: {
    tap() {
      this.count++;
      if (this.count > 30) {
        window.localStorage.removeItem('friendpass_sent');
        window.location.reload();
      }
    }
  }
};